import Controller from '@ember/controller';
import { inject as service } from '@ember/service';
import { inject as controller } from '@ember/controller';
import AdBlocker from 'cio/services/ad-blocker';
import CustomFormsService from 'cio/services/custom-forms';
import EnvironmentService from 'cio/services/environment';
import FacebookLeadAdsService from 'cio/services/facebook-lead-ads';
import AuthService from 'cio/services/auth';
import IntegrationsFormsController from 'cio/pods/integrations/forms/controller';
import { tracked } from '@glimmer/tracking';
import { FormType } from 'cio/utils/forms';
import { isEmpty } from '@ember/utils';
import { computed } from '@ember/object';
import { FormIntegrationDetailPanes } from 'cio/components/forms/custom/integration-details';

type SelectableForm = {
  type: FormType;
  icon: string;
  label: string;
  detail: string;
  enabled: boolean;
};

export default class IntegrationsFormsGeneralController extends Controller {
  @service adBlocker!: AdBlocker;
  @service facebookLeadAds!: FacebookLeadAdsService;
  @service customForms!: CustomFormsService;
  @service environment!: EnvironmentService;
  @service auth!: AuthService;

  @controller('integrations/forms') baseController!: IntegrationsFormsController;

  readonly panes = FormIntegrationDetailPanes;
  readonly FormType = FormType;

  @computed('customForms.forms.[]', 'facebookLeadAds.connectedNowOrBeforeForms.[]')
  get hasForms() {
    return !isEmpty(this.customForms.forms) || !isEmpty(this.facebookLeadAds.connectedNowOrBeforeForms);
  }

  // relevant to choosing form to connect
  @tracked formToConnect: SelectableForm | null = null;
  get formsToConnect() {
    let custom: SelectableForm = {
      type: FormType.Custom,
      icon: 'form',
      label: 'Custom Form',
      detail: 'Send submissions from a form built by you or one of our suggested providers.',
      enabled: this.customForms.canConnectForms,
    };
    let facebookLeadAds: SelectableForm = {
      type: FormType.FacebookLeadAds,
      icon: 'facebook',
      label: 'Facebook Lead Ads',
      detail: 'Send submissions from Facebook.',
      enabled: this.facebookLeadAds.isAvailable,
    };
    let jotform: SelectableForm = {
      type: FormType.Jotform,
      icon: 'jotform',
      label: 'Jotform',
      detail: 'Send submissions from your Jotform forms using a webhook.',
      enabled: true,
    };
    let typeform: SelectableForm = {
      type: FormType.Typeform,
      icon: 'typeform',
      label: 'Typeform',
      detail: 'Send submissions from your Typeform forms using a webhook.',
      enabled: true,
    };

    return [custom, facebookLeadAds, typeform, jotform].compact();
  }

  setDefaults() {
    this.setProperties({
      formToConnect: null,
    });
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your controllers.
declare module '@ember/controller' {
  interface Registry {
    'integrations/forms/general': IntegrationsFormsGeneralController;
  }
}
